// tslint:disable:jsx-no-lambda
// tslint:disable:jsx-no-multiline-js
import * as React from 'react';

import { Button, Modal, TextInput, VALIDATION_STATE } from '@abb/common-ux';
import { ISite } from '@module/shared';

interface IAssignSiteModalProps {
  isOpen: boolean;
  site?: ISite;
  onClose: () => void;
  onAddClick: (servIsId: string) => Promise<ISite | null>;
  onConfirmClick: (site: ISite) => Promise<boolean>;
}

interface IAssignSiteModalState {
  siteId?: string;
  siteIdValidation: VALIDATION_STATE;
  site?: ISite;
  waiting: boolean;
}

export class AssignSiteModal extends React.Component<IAssignSiteModalProps, IAssignSiteModalState> {
  constructor(props: IAssignSiteModalProps) {
    super(props);

    this.state = {
      siteId: this.props.site ? this.props.site.servIsId : undefined,
      siteIdValidation: this.props.site ? 'valid' : 'none',
      site: this.props.site,
      waiting: false,
    };
  }

  componentDidUpdate(prevProps: IAssignSiteModalProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      this.setState({ 
        siteId: this.props.site ? this.props.site.servIsId : undefined, 
        siteIdValidation: this.props.site ? 'valid' : 'none', 
        site: this.props.site});
    }
  }

  render() {
    return (
      <Modal header='Assign a Site' isOpen={this.props.isOpen} onClose={this.props.onClose} modalClassName='assignSiteModal'>
        <div className='row'>
          <div className='col-sm-10'>
            <TextInput 
              name='siteId'
              labelText='Site ID'
              inputSize='small'
              validationState={this.state.siteIdValidation}
              placeholder={'Enter a Site ID'}
              errorMessage={'We couldn\'t find a Site with that Site ID'}
              value={this.state.siteId || ''}
              onChange={this.onSiteChange}
              onKeyDown={this.onEnter}
            />
          </div>
          <div className='col-sm-2' style={{ marginTop: 22, textAlign: 'center' }}>
            {this.state.waiting ?
            <div className='Spinner_root Spinner_blue Spinner_small'>
              <svg
                viewBox='0 0 100 100'>
                <circle cx='50' cy='50' r='45' />
              </svg>
            </div> :
            <Button
              buttonType='normal'
              buttonSize='small'
              icon='search'
              style={{ width: '100%' }}
              disabled={!this.state.siteId || this.state.siteId.trim() === ''}
              onClick={this.onAddClick}  
            >Search</Button>
            }
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12'>
            <a href={environmentSettings.servisUrl} target='_blank'>Advanced Search in ServIS</a>
          </div>
        </div>
        {this.state.site &&
          <React.Fragment>
            <br/>
            <div className='row'>
              <div className='col-sm-3'>Site</div>
              <div className='col-sm-3'>ServIS ID</div>
              <div className='col-sm-3'>City</div>
              <div className='col-sm-3'>Country</div>
            </div>
            <div className='row'>
              <div className='col-sm-3 boldText'>{this.state.site.siteName}</div>
              <div className='col-sm-3 boldText'>{this.state.site.servIsId}</div>
              <div className='col-sm-3 boldText'>{this.state.site.city}</div>
              <div className='col-sm-3 boldText'>{this.state.site.country}</div>
            </div>
            <br/>
            <div className='row'>
              <div className='col-sm-6'>Owner</div>
              <div className='col-sm-6'>Operator</div>
            </div>
            <div className='row'>
              <div className='col-sm-6 boldText'>
                {this.state.site.ownerId ?
                `${this.state.site.ownerId} - ${this.state.site.ownerName}` :
                this.state.site.ownerName}
              </div>
              <div className='col-sm-6 boldText'>
                {this.state.site.operatorId ?
                `${this.state.site.operatorId} - ${this.state.site.operatorName}` :
                this.state.site.operatorName}
              </div>
            </div>
            <br/>
            <div className='row'>
              <div className='col-sm-offset-8 col-sm-2'>
                <Button
                  buttonType='normal'
                  buttonSize='small'
                  style={{ width: '100%' }}
                  onClick={this.props.onClose}
                >Cancel</Button>
              </div>
              <div className='col-sm-2'>
              <Button
                  buttonType='primary'
                  buttonSize='small'
                  style={{ width: '100%' }}
                  disabled={this.props.site && this.state.site && this.props.site.servIsId === this.state.site.servIsId}
                  onClick={this.onConfirmClick}
                >Assign</Button>
              </div>
            </div>
          </React.Fragment>
        }
      </Modal>
    );
  }

  onClose = () => {
    this.setState({ siteId: undefined });
    this.props.onClose();
  }

  onSiteChange = (event: React.ChangeEvent<any>) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const newValue = {};
    newValue[name] = value;
    this.setState({ siteId: event.target.value });
  }

  onAddClick = async () => {
    this.setState({ site: undefined, waiting: true });
    const site = await this.props.onAddClick(this.state.siteId!);
    if (site !== null) {
      this.setState({ site, siteIdValidation: 'valid', waiting: false });
    } else {
      this.setState({ siteIdValidation: 'invalid', waiting: false });
    }
  }

  onEnter = async (e: any) => {
    if (e.key === 'Enter' && this.state.siteId && this.state.siteId.trim() !== '') {
      await this.onAddClick();
    }
  }

  onConfirmClick = async () => {

    if (await this.props.onConfirmClick(this.state.site!)) {
      this.props.onClose();
    }
  }
}
